document.addEventListener('DOMContentLoaded', () => {
    const expireForm = document.getElementById('expireForm');
    const deleteExpireId = document.getElementById('deleteExpireId');

    if (!expireForm || !deleteExpireId) {
        return;
    }

    document.querySelectorAll('[pid="I00077"]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            const row = btn.closest('tr');
            if (!row) {
                return;
            }

            const corporationIdCell = row.querySelector('td:nth-child(3)');
            const corporationId = corporationIdCell ? corporationIdCell.textContent.trim() : '';

            const message = window.MESSAGE_SETTINGS.share.MSG0036;

            const result = await window.showConfirm(message);
            if (result) {
                deleteExpireId.value = corporationId;
                expireForm.submit();
            }
        });
    });
});
